import React from "react";

const Profile = ({ account }) => {
  return (
    <div>
      <h2>Welcome, {account.name}</h2>
      <p>Email: {account.username}</p>
    </div>
  );
};

export default Profile;
